import BarCode from 'react-barcode';
import React from 'react'


class ComponentToPrintOne extends React.Component {
    render() {
        return  <div id="wrapper_ref" className="print-element">
        <BarCode
            value={this.props.barcodeValue}
        />
    </div>
    }
}
 export default ComponentToPrintOne;